import { Component, Inject, Input, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import Swal from "sweetalert2";

@Component({
  selector: 'app-osa-execucao-aba-papaeis-modal-incluir',
  templateUrl: './osa-execucao-aba-papaeis-modal-incluir.component.html',
  styleUrls: ['./osa-execucao-aba-papaeis-modal-incluir.component.scss']
})

export class OsaExecucaoAbaPapaeisModalIncluirComponent implements OnInit {

  novoItem: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<OsaExecucaoAbaPapaeisModalIncluirComponent>
  ) {}

  ngOnInit(): void {}

  cancelar(): void {
    this.dialogRef.close();
  }

  salvar(): void {

    if (this.novoItem.length > 100) {
      this.mensagem("O nome do Papel de Trabalho não pode ter mais de 100 caracteres!");
      return;
    }

    this.dialogRef.close(this.novoItem);
  }

  mensagem(msg: string) {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "warning",
      html: msg,
      showConfirmButton: false,
      showCloseButton: true,
      title: "",
    });
  }
}
